import {z} from 'zod';

export enum AssetSetType {
	ASSET = 'asset',
	ASSET_SET = 'assetSet',
	CART = 'cart',
	CATEGORY = 'category',
	SAVED_CART = 'savedCart',
	SAVED_SEARCH = 'savedSearch',
}

export const AssetSetSchema = z.object({
	ids: z.array(z.number().int().positive()),
	recursive: z.boolean(),
	type: z.nativeEnum(AssetSetType),
});

export default AssetSetSchema;

export type IAssetSet = z.infer<typeof AssetSetSchema>;

/** all fields */
export const AssetSetField = AssetSetSchema.keyof().enum;
